// Module
var code = "<script id=\"wcc-components-wcc-link\" type=\"text/template\">\r\n    <!-- ko customElement: layoutConfig --><!-- /ko -->\r\n</script>";
// Exports
module.exports = code;